import { cx } from '@hrworks/design-system/functions';
import { useMediaQuery } from '@hrworks/design-system/hooks';
import { FontAwesomeIcon } from '@hrworks/sui-core/FontAwesomeIcon';
import type { IconButtonProps } from '@hrworks/sui-core/IconButton';

import { useSqwLayout } from '../SqwLayoutContext';
import { S } from './SidebarToggle.styles';

export const SidebarToggle = ({ className, ...otherProps }: IconButtonProps) => {
  const {
    isSidebarExpanded,
    setIsSidebarExpanded,
    isMobileSidebarExpanded,
    setIsMobileSidebarExpanded,
    desktopSidebarTogglerMode,
  } = useSqwLayout();
  const isSmallDevice = useMediaQuery('isSmallDevice');

  const isExpanded = isSmallDevice ? isMobileSidebarExpanded : isSidebarExpanded;
  const toggle = isSmallDevice
    ? () => setIsMobileSidebarExpanded(!isMobileSidebarExpanded)
    : () => setIsSidebarExpanded(!isSidebarExpanded);

  return (
    <S.SidebarToggle
      className={cx(S.cls.SidebarToggle, className)}
      $desktopSidebarTogglerMode={desktopSidebarTogglerMode}
      aria-expanded={isExpanded}
      onClick={toggle}
      {...otherProps}
    >
      <FontAwesomeIcon name="bars" variant="regular" />
    </S.SidebarToggle>
  );
};
